<template>
  <div id="app">
    <FullPageLoader></FullPageLoader>
    <div id="appWrapper">
      <Navigation></Navigation>
      <Alert></Alert>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
      <Message></Message>
      <DataLoading></DataLoading>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/layout/Navigation'
import Alert from '@/components/elements/Alert'
import Message from '@/components/layout/Message'
import DataLoading from '@/components/layout/DataLoading'
import FullPageLoader from '@/components/layout/FullPageLoader'
import DataMain from '@/data/dataMain'
import DataUser from '@/data/controllers/DataUser'
import {store} from '@/store'
import { format as dateFnsformat } from 'date-fns'
// import { isToday } from 'date-fns'

export default {
  name: 'App',
  components: {
    'Navigation': Navigation,
    'Alert': Alert,
    'Message': Message,
    'DataLoading': DataLoading,
    'FullPageLoader': FullPageLoader
  },
  data () {
    return {
      test: null
    }
  },
  computed: {
    key () {
      return store.state.key
    }
  },
  async created () {
    let da = new Date()
    da = dateFnsformat(da, 'YYYY-MM-DD')
    store.commit('setDate', {
      value: da
    })
    if (this.$cookie.get('key')) {
      store.commit('updateKey', {
        key: this.$cookie.get('key')
      })
      // Sync and set up interval sync at 10 seconds
      DataMain.syncActivities()
      DataMain.setSyncCheck()
      window.addEventListener('blur', function () {
        console.log('blur')
        DataMain.removeSyncCheck()
      })

      window.addEventListener('focus', function () {
        console.log('focus')
        DataMain.syncActivities()
        DataMain.setSyncCheck()
      })
    }

    this.$router.afterEach((to, from, next) => {
      /* must call `next` */
      /* Matomo */
      var _paq = window._paq || []
      var currentUrl = 'https://everyday.next-iteration.net/'
      _paq.push(['setReferrerUrl', currentUrl + from.path])
      currentUrl += '' + to.path
      _paq.push(['setCustomUrl', currentUrl])
      _paq.push(['setDocumentTitle', to.name])

      // remove all previously assigned custom variables, requires Matomo (formerly Piwik) 3.0.2
      _paq.push(['deleteCustomVariables', 'page'])
      _paq.push(['setGenerationTimeMs', 0])
      _paq.push(['trackPageView'])

      // make Matomo aware of newly added content
      var content = document.getElementById('content')
      _paq.push(['MediaAnalytics::scanForMedia', content])
      _paq.push(['FormAnalytics::scanForForms', content])
      _paq.push(['trackContentImpressionsWithinNode', content])
      _paq.push(['enableLinkTracking'])
      /* End Matomo */
    })
  },
  mounted () {
    let $this = this
    DataUser.getUserData()
    setTimeout(function () {
      $this.checkStandAlone()
    }, 1000)
    // alert(isToday(new Date()))
  },
  methods: {
    redirect (page) {
      this.$router.push(page)
    },
    checkStandAlone () {
      const userAgent = window.navigator.userAgent.toLowerCase()
      const isIOS = /iphone|ipad|ipod/.test(userAgent)
      const currentTimestamp = Date.now()
      const daysToCheck = 7
      const checkDate = currentTimestamp - (1000 * 60 * 24 * daysToCheck)
      let doNotShow = false
      if (localStorage.standAloneDate) {
        if (checkDate < localStorage.standAloneDate) {
          doNotShow = true
        }
      }
      if (window.navigator.standalone || !isIOS || doNotShow) {
        // alert('standalone!')
        return false
      }
      // alert(store.state.user.installInfo.standAloneDate)
      store.commit('setMessage', {
        message: 'Install this webapp to your device: tap <img height="20" src="/images/add-to-home-apple-white.png" alt="add to device" /> and then Add to Homescreen',
        onClose: 'noinstall'
      })
    }
  }
}
</script>

<style lang="scss">
@import '/scss/styles.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue